// types
import {Coin, UserInfo, UserProps, UpdateUser, IUser} from "app/types/user";
import {PayloadAction, createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {MoneyType} from "app/types/common";
import {RootState} from "app/store";
import apiAuth from "app/api/auth";
import client from "app/api/client";

// initial state
const initialState: UserProps = {
    token: undefined,
    isLogin: false,
    user: undefined,
    balance: [],
    turnoverData: [],
    userCurrency: MoneyType.USDT,
    cashBackDataAmount: 0,
    kycExtraVos: [],
    vipCheckCanReceive: false,
    cashBackDataRealAmount: 0,
    otherInfoUser: undefined,
    reconnectWebSocket: true,

    isOpen2FaModal: false,
    is2FaData: {},
    is2FaType: '',
};

// ==============================|| SLICE - MENU ||============================== //

export const getUserTurnover = createAsyncThunk("user/getUserTurnover", async () => {
    const response = await apiAuth.getWithdrawLimit();
    if (response.status === 200 && response.data.code === 0) {
        return response.data.data;
    }
});

export const refreshCashBackData = createAsyncThunk("refreshCashBackData", async () => {
    const {status, data} = await apiAuth.getVipCashbackData();
    if (status === 200 && data.code === 0) {
        return data.data;
    }
});

export const refreshRealCashBackData = createAsyncThunk("refreshRealCashBackData", async () => {
    const {status, data} = await apiAuth.getVipInstantCashbackData();
    if (status === 200 && data.code === 0) {
        return data.data;
    }
});

const user = createSlice({
    name: "user",
    initialState,
    reducers: {
        open2FaModal: (state) => {
            state.isOpen2FaModal = true;
        },
        close2FaModal: (state) => {
            state.isOpen2FaModal = false;
            state.is2FaData = {};
            state.is2FaType = '';
        },
        setData2Fa: (state, action: PayloadAction<{data: any; type: string}>) => {
            state.is2FaData = action.payload.data;
            state.is2FaType = action.payload.type;
        },
        loginSuccess(state, action: PayloadAction<UserInfo>) {
            state.user = action.payload;
            state.token = action.payload.token;
            state.kycExtraVos = action.payload.kycExtraVos;
            state.isLogin = true;
            state.reconnectWebSocket = true;
            client.setToken(action.payload.token);
        },

        loginOut(state) {
            state.user = undefined;
            state.isLogin = false;
            state.token = undefined;
            localStorage.removeItem("popupData");
        },

        setOtherInfoUser: (state, action: PayloadAction<IUser>) => {
            state.otherInfoUser = action.payload;
        },

        setBalance: (state, action: PayloadAction<Coin[]>) => {
            state.balance = action.payload;
        },
        setUserCurrency: (state, action) => {
            state.userCurrency = action.payload;
            localStorage.setItem("userMoneyType", action.payload);
        },
        updateKycExtraVos: (state, action: PayloadAction<{validateData: string; validateType: number}>) => {
            const tempData = [...state.kycExtraVos].filter((x) => x.validateType !== action.payload.validateType);
            tempData.push({validateData: action.payload.validateData, validateType: action.payload.validateType});
            state.kycExtraVos = tempData;
        },

        updateUserInfo: (state, action: PayloadAction<UpdateUser>) => {
            const tempData = {...state.user!, ...action.payload};
            state.user = tempData;
        },
        setPddActStatus: (state, action: PayloadAction<0 | 1>) => {
            state.user = {...state.user!, pddActEnable: action.payload};
        },
        setReconnectWebSocket: (state, action: PayloadAction<boolean>) => {
            state.reconnectWebSocket = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getUserTurnover.fulfilled, (state, action) => {
            try {
                const jsonData = JSON.parse(action.payload);
                state.turnoverData = jsonData?.data || [];
            } catch (error) {}
        });
        builder.addCase(refreshRealCashBackData.fulfilled, (state, action: PayloadAction<number>) => {
            // state.cashBackDataRealAmount = action.payload;
        });
        builder.addCase(refreshCashBackData.fulfilled, (state, action: PayloadAction<{amount: number; realAmount: number}>) => {
            state.cashBackDataAmount = action.payload.amount;
            state.cashBackDataRealAmount = action.payload.realAmount;
        });
    },
});

export const getBalance = (state: RootState) => state.user.balance;

export const getUserMoneyType = (state: RootState) => state.user.userCurrency;

export default user.reducer;

export const {setData2Fa, close2FaModal, open2FaModal, setReconnectWebSocket, loginSuccess, loginOut, setBalance, setOtherInfoUser, setUserCurrency, updateKycExtraVos, updateUserInfo, setPddActStatus} = user.actions;
